//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import startCase from 'lodash/startCase'

import { getFieldValue } from 'utils/ticketFields'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarBadges from 'components/Shared/Sidebar/SidebarBadges/Index'

const SidebarBadgesSection = ({ field }) => {
  const textValue = getFieldValue(field)
  const badges = field.value?.map(val => {
    return ({
      value: val,
      title: val,
    })
  }) || []

  return (
    <SidebarSection
      title={startCase(field.name)}
      tooltipText={field.tooltipText}
      copyText={textValue}
      key={field.id}
    >
      <SidebarBadges badges={badges} />
    </SidebarSection>
  )
}

SidebarBadgesSection.propTypes = {
  field: PropTypes.object,
}

export default SidebarBadgesSection
